// src/components/ui/icon/icons/BuilderIcon.tsx
import { jsx } from "react/jsx-runtime";
var BuilderIcon = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M3.66691 6.33333V9C3.66691 9.35362 3.80739 9.69276 4.05744 9.94281C4.30748 10.1929 4.64662 10.3333 5.00024 10.3333H7.66691M2.33358 1H5.00024C5.73662 1 6.33358 1.59695 6.33358 2.33333V5C6.33358 5.73638 5.73662 6.33333 5.00024 6.33333H2.33358C1.5972 6.33333 1.00024 5.73638 1.00024 5V2.33333C1.00024 1.59695 1.5972 1 2.33358 1ZM9.00024 7.66667H11.6669C12.4033 7.66667 13.0002 8.26362 13.0002 9V11.6667C13.0002 12.403 12.4033 13 11.6669 13H9.00024C8.26386 13 7.66691 12.403 7.66691 11.6667V9C7.66691 8.26362 8.26386 7.66667 9.00024 7.66667Z",
        stroke: "currentColor",
        strokeWidth: "1.33",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
);
var BuilderIcon_default = BuilderIcon;

export {
  BuilderIcon_default
};
//# sourceMappingURL=chunk-YED5ZWKI.js.map